import { gql, useQuery } from "@apollo/client";

const GET_PAYMENTS_RECEIVED = gql`
  query GetPaymentsReceived(
    $region: ID
    $district: ID
    $tariffClass: ID
    $tariffClasses: [ID]
    $serviceClass: ServiceClass
    $serviceClasses: [ServiceClass]
    $month: PositiveInt!
    $year: PositiveInt!
    $page: Int
    $pageSize: Int
    $search: String
    $searchFields: [String!]
    $sort: String
  ) {
    rows: getPaymentsReceived(
      region: $region
      district: $district
      tariffClass: $tariffClass
      tariffClasses: $tariffClasses
      serviceClass: $serviceClass
      serviceClasses: $serviceClasses 
      month: $month
      year: $year
      page: $page
      pageSize: $pageSize
      search: $search
      searchFields: $searchFields
      sort: $sort
    ) {
      _id
      servicePointCode
      servicePointStatus
      tariffClassCode
      tariffClassName
      serviceClass
      geoCode
      accountCode
      meterCode
      meterModelType
      regionCode
      regionName
      districtCode
      districtName

      customerName
      externalTransactionCode
      paymentDate
      paymentTime
      receivedDate
      receivedTime
      processedDate
      processedTime
      status
      origin
      type
      subType
      amount

      month
      year
      createdAt
      updatedAt
    }
    count: getPaymentsReceivedCount(
      region: $region
      district: $district
      tariffClass: $tariffClass
      tariffClasses: $tariffClasses
      serviceClass: $serviceClass
      serviceClasses: $serviceClasses
      month: $month
      year: $year
      search: $search
      searchFields: $searchFields
    )
  }
`;

export const usePaymentsReceived = (variables: any) => {
  const { data, ...rest } = useQuery(GET_PAYMENTS_RECEIVED, {
    variables,
    notifyOnNetworkStatusChange: true,
  });
  const rows = data?.rows || [];
  const count = data?.count || 0;
  return { rows, count, ...rest };
};
